import { IllegalRecordHandleResult, IllegalRecordHandleState } from '@36node-fcp/core-sdk';
import { DownOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Dropdown, Input, Row, Space } from 'antd';
import { useCallback, useState } from 'react';

import { IllegalHandleResultUiList } from 'src/features/illegal';

export function IllegalHandleDropdown({
  handleState,
  onConfirm,
  className,
}: {
  handleState?: IllegalRecordHandleState;
  onConfirm?: (payload: {
    handleState: IllegalRecordHandleState;
    handleResults?: IllegalRecordHandleResult[];
    handleDescription?: string;
  }) => void;
  className?: string;
}) {
  const [open, setOpen] = useState(false);
  const [results, setResults] = useState<IllegalRecordHandleResult[]>([]);
  const [text, setText] = useState('');

  const handleOpenChange = (nextOpen: boolean) => {
    setOpen(nextOpen);
  };

  const handleConfirm = useCallback(() => {
    setOpen(false);
    onConfirm?.({
      handleState: IllegalRecordHandleState.CLOSED,
      handleResults: results,
      handleDescription: text,
    });
  }, [results, text, onConfirm]);

  const dropdownContent = (
    <div
      style={{
        padding: 16,
        width: 280,
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        boxShadow: '0 6px 16px rgba(0,0,0,0.08)',
      }}
    >
      <div style={{ padding: '8px 12px', marginTop: 8 }}>
        <Checkbox.Group
          value={results}
          onChange={(v) => setResults(v as IllegalRecordHandleResult[])}
          style={{ width: '100%' }}
        >
          <Row gutter={[8, 8]}>
            {IllegalHandleResultUiList.map(({ value, text }, index) => (
              <Col span={index < 2 ? 24 : 12} key={value}>
                <Checkbox value={value}>{text}</Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>

        <div style={{ marginTop: 8 }}>
          <Input placeholder="备注" value={text} onChange={(e) => setText(e.target.value)} allowClear />
        </div>
      </div>

      <div style={{ marginTop: 12, textAlign: 'right' }}>
        <Space>
          <Button onClick={() => setOpen(false)}>取消</Button>
          <Button type="primary" onClick={handleConfirm}>
            确认
          </Button>
        </Space>
      </div>
    </div>
  );

  return (
    <Dropdown
      className={className}
      open={open}
      onOpenChange={handleOpenChange}
      dropdownRender={() => dropdownContent}
      trigger={['click']}
      placement="bottomRight"
    >
      <Button>
        {handleState === IllegalRecordHandleState.OPEN ? '处置' : '处置中'} <DownOutlined />
      </Button>
    </Dropdown>
  );
}
